import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCommonData } from '../rtk-apis/common/getCommonData';
import { RootState, AppDispatch } from '../store/store';

export default function GlobalCommonDataLoader() {
  const dispatch = useDispatch<AppDispatch>();
  const status = useSelector((state: RootState) => state.getCommonDataSliceResponse.status);

  useEffect(() => {
    if (!status) {
      dispatch(getCommonData({}));
    }
  }, [dispatch, status]);
  return null;
}
